<template>
  <div class="count">
    <div class="tp">
      <div class="h2">{{ title }}</div>
      <div v-if="!isOther">
        <a href="javascript:void(0);" @click='send'
          v-if='type && $common.AccAUTH($store.state.cause.accuser.id, "cause:credit:edit") && !isAllDis && $store.getters.debInfo.is_clear != 1 && $store.state.cause.invaild != 1'
          class="send">确认</a>
      </div>
      <label>合计：</label> <b>{{ Allfree(sition) | toNum }}</b>
      <div v-if='type' style="padding-left:20px;" class="oform">
        <label> 已履行：</label>
        <b>{{ payeeFee | showYuan }}</b>
        <!-- <label>银行结清金额</label>
            <a-input type="number" v-model='bank_clear_fee' placeholder="请输入" style="width:100px;margin-left:20px;" @keyup.enter.native='kNum($event)' :disabled='isAllDis || $store.state.cause.invaild==1' /> -->
      </div>
    </div>
    <div class="inlist">
      <div class="li" v-for='(i, index) in sition' :key="index">
        <div class="btit" v-if='!type'>{{ index | ht3 }}</div>
        <div class="btit" v-else>{{ index | ht2 }}</div>
        <div class="tit">{{ i.type_title }}</div>
        <div class="say" :class='{ "noNum": i.fee == 0, "edit": i.audit && type }'>
          <!-- @keyup="handleInput2" -->
          <input type="number" v-model='i.fee' @blur='rNum(i.fee, index)'
            :disabled='!type || isAllDis || i.type == 6 || $store.state.cause.invaild == 1 || (i.audit && type)'
            placeholder="请输入" v-if='$common.AUTH("cause:credit:edit")' />
          <input type="number" v-model='i.fee' disabled v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sendCredit,
  bankClearFee
} from "@/server/api"
import step from "./step.json"
export default {
  name: 'Count',
  props: {
    isOther: Boolean, //只显示不做操作
    payeeFee: Number,
    payee: Number,
    title: String,
    type: Boolean,
    used_fee: Number,
    bankFee: Number,
    seeCapital: Number,
    Credit: { //确认债权下对比主张债权
      type: Array,
      data() {
        return []
      },
    },
    Proposition: {
      type: Array,
      data() {
        return []
      }
    }
  },
  computed: {
    isAllDis() {
      return this.$route.query.t || this.$route.name === 'InDetails'
    }
  },
  data() {
    return {
      sition: [],
      hasone: false,
      countCredit: [], //确认债权下 主张债权计算
      isback: false,
      bank_clear_fee: 0
    }
  },
  created() {
    if (this.Proposition) {
      this.sition = this.getCount(this.Proposition, this.type) //主张债权 确认债权 当前值
    }
    if (this.Credit) { //确认债权下 主张债权数组
      this.countCredit = this.getCount(this.Credit, false)
    }
    if (this.type) {
      const hasone = this.sition.filter(ele => {
        return ele.fee
      }).length == 0
      this.hasone = hasone
    }
  },
  filters: {
    ht3(val) {
      const tit = {
        0: '主张债权',
        2: '代理费用',
        4: '诉讼费用'
      }
      return tit[val]
    },
    ht2(val) {
      const tit = {
        0: '确认债权',
        2: '代理费用',
        4: '诉讼费用'
      }
      return tit[val]
    }
  },
  watch: {
    bankFee: {
      handler(newVal) {
        this.bank_clear_fee = newVal
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getCount(value, bool) {
      let arr = JSON.parse(JSON.stringify(this.rPropo(value)))
      if (!bool) {
        arr[0].fee = this.seeCapital
        arr[1].fee = this.used_fee
      }
      arr.map(ele => {
        if (ele.fee == 0 && this.type) ele.fee = ''
        else {
          ele.copyFee = ele.fee / 100
          ele.fee = ele.fee / 100
        }
      })
      return arr
    },
    rNum(value, index) {
      const countCredit = JSON.parse(JSON.stringify(this.countCredit)),
        sition = JSON.parse(JSON.stringify(this.sition));
      if (value == sition[index].copyFee) return false
      if (Math.abs(countCredit[index].fee * 1 - value * 1) > 10000) {
        this.$modal.confirm({
          content: countCredit[index].type_title + '是否输入错误？',
          cancelText: "输入错误",
          okText: "输入正确",
          onOk: () => {
          },
          onCancel: () => {
            this.sition[index].fee = this.sition[index].copyFee
          }
        });
      }
    },
    kNum() {
      if (this.isback || !this.bank_clear_fee) return false;
      this.isback = true;
      bankClearFee({
        bank_clear_fee: this.bank_clear_fee,
        cause_id: this.$store.state.cause.id
      }).then(e => {
        this.$message.success('银行结清成功');
        this.isback = false;
      })
    },
    rPropo(Arr) {
      let newArr = []
      step.map(ele => {
        let s = Arr.find(s => {
          return s.type == ele.type
        })
        let data = {
          type_title: ele.tit,
          type: ele.type,
          fee: s ? s.fee : 0
        }
        if (this.type && s.audit) {
          data.audit = s.audit.length > 0
        }
        newArr.push(data)
      })
      return newArr
    },
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    handleInput2(e) {
      e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
      const reg = /[^\d.]/g;
      // 只能是数字和小数点，不能是其他输入
      e.target.value = e.target.value.replace(reg, "");
      // 保证第一位只能是数字，不能是点
      e.target.value = e.target.value.replace(/^\./g, "");
      // 小数只能出现1位
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      // 小数点后面保留2位
      e.target.value = e.target.value.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        "$1$2.$3"
      );
    },
    Allfree(Arr) {
      let i = 0;
      Arr.map(e => {
        if (e.type != 6) {
          i += e.fee * 1
        }
      })
      return i
    },
    send() {
      let data = this.sition.map(ele => {
        return {
          type: ele.type,
          fee: ele.fee * 100
        }
      }).filter(ele => {
        return ele.fee >= 0
      })
      if (data.length == 0) {
        return false;
      }
      sendCredit({
        list: data,
        cause_id: this.$store.state.cause.id
      }).then(e => {
        this.$message.success({
          content: this.hasone ? '已提交' : '已提交审核',
          key: 'updatable'
        });
        this.$store.dispatch('Case/getlist', {
          debtor_id: this.$route.params.id,
        })
        this.$emit('resh')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.count {
  padding: 0 20px 20px 20px;
  overflow: hidden;

  .tp {
    font-size: 1rem;
    color: #0e2949;
    line-height: 60px;
    // margin: 22px 0 11px;
    display: flex;
    align-items: center;

    .h2 {
      margin-right: 30px;
      margin-bottom: 0;
      font-size: 16px !important;
      font-weight: bold;
      color: #0e2949;
    }

    b {
      font-size: 1.125rem;
    }

    label {
      font-size: 0.875rem;
    }
  }

  .inlist {
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #f8f9fb;
    padding: 0px 15px;
    // margin: 0 4px;

    .btit {
      position: absolute;
      top: 20px;
      left: 0;
      font-size: 15px;
      font-weight: bold;
      color: #0e2949;
      line-height: 22px;
    }

    .li {
      float: left;
      width: 9%;
      display: flex;
      align-items: center;
      padding: 56px 0 25px 0;
      position: relative;

      &:nth-child(1),
      &:nth-child(2) {
        width: 12%;
      }

      /* 前两个 li 内的 tit：margin-right: 10px */
      &:nth-child(1) .tit,
      &:nth-child(2) .tit {
        margin-right: 10px;
      }

      /* 其余所有 li 内的 tit：margin-right: 5px */
      &:nth-child(n+3) .tit {
        margin-right: 8px;
      }

      .tit {
        font-size: 0.875rem;
        color: #0e2949;
        white-space: nowrap;
      }

      .say input {
        width: 100%;
        line-height: 40px;
        border-radius: 4px;
        border: 1px solid #dbdcde;
        color: #333;
        text-align: center;
      }

      .edit input {
        border: 1px solid #ff9800;
      }

      input::-webkit-input-placeholder {
        color: rgba(14, 41, 73, 0.3);
      }

      input::-moz-input-placeholder {
        color: rgba(14, 41, 73, 0.3);
      }

      input::-ms-input-placeholder {
        color: rgba(14, 41, 73, 0.3);
      }

      .noNum {
        input {
          color: rgba(14, 41, 73, 0.3);
        }
      }
    }
  }

  .send {
    width: 40px;
    line-height: 25px;
    background: #1d8bfe;
    border-radius: 4px;
    display: block;
    text-align: center;
    color: #fff;
    font-size: 0.875rem;
    margin-right: 12px;
  }

  .all {
    color: #0e2949;
    font-size: 1rem;
    padding: 0 38px 24px;

    b {
      font-size: 26px;
      font-weight: normal;
    }

    .rt {
      display: flex;
      align-items: self-end;
    }

    .small {
      color: rgba(14, 41, 73, 0.3);
      margin-left: 5px;
      font-size: 0.75rem;
    }
  }
}

.oform {
  display: flex;
  white-space: nowrap;
  align-items: center;

  b {
    margin-right: 20px;
  }
}
</style>